import { get, post } from '@/api/lib/amplify-wrapper'
import { createImpersonatedApiHeaders } from '@/lib/services/api-utils'

const API_NAME = 'recruitment'

export interface JobPosting {
  id: string
  jobPostingId: string
  tenantId: string
  title: string
  department: string
  location: string
  workMode: 'remote' | 'hybrid' | 'onsite'
  employmentType: 'clt' | 'pj' | 'internship' | 'temporary'
  seniority: 'junior' | 'mid' | 'senior' | 'specialist'
  description: string
  responsibilities: string[]
  requirements: { technical: string[]; behavioral: string[] }
  benefits: string[]
  salaryRange: { min: number; max: number; currency: string } | null
  status: 'draft' | 'active' | 'closed' | 'archived'
  visibility: 'public' | 'internal' | 'confidential'
  createdAt: string
  updatedAt: string
}

/**
 * List job postings
 */
export const listJobPostings = async (includeAll = true): Promise<{ items: JobPosting[]; nextToken?: string }> => {
  const path = `/recruitment/job-postings?includeAll=${includeAll}`

  const restOperation = get({
    apiName: API_NAME,
    path,
    options: {
      headers: createImpersonatedApiHeaders()
    }
  })

  const response = await restOperation.response
  const data = await response.body.json()
  return data as unknown as { items: JobPosting[]; nextToken?: string }
}

/**
 * Create a job posting
 */
export const createJobPosting = async (data: {
  title: string
  department: string
  description: string
  location?: string
  workMode?: string
  employmentType?: string
  seniority?: string
  responsibilities?: string[]
  requirements?: { technical: string[]; behavioral: string[] }
  benefits?: string[]
  salaryRange?: { min: number; max: number; currency: string } | null
  status?: string
  visibility?: string
}): Promise<JobPosting> => {
  const path = '/recruitment/job-postings'

  const restOperation = post({
    apiName: API_NAME,
    path,
    options: {
      body: data as any,
      headers: createImpersonatedApiHeaders()
    }
  })

  const response = await restOperation.response
  const result = await response.body.json()
  return result as unknown as JobPosting
}

export const recruitmentApi = {
  listJobPostings,
  createJobPosting
}
